import { Validators } from "@angular/forms"
import { IFormKey } from "src/app/modules/shared/models/forms"

export const address_change_form_template = {
    country: null,
    place: {value: null, disabled: true},
    province: {value: null, disabled: true},
    postalCode: {value: null, disabled: true},
    toponym: {value: null, disabled: true},
    address: {value: null, disabled: true},
    addressNumber: {value: null, disabled: true}
}

export const address_change_form_validators = {
    country: [Validators.required],
    place: [Validators.required],
    province: [Validators.required],
    postalCode: [Validators.required, Validators.pattern(/^\d{5}$/)],
    toponym: [Validators.required],
    address: [Validators.required],
    addressNumber: [Validators.required]
}

export const address_change_form_keys: IFormKey[] = [
    {
        id: 'country-field',
        label: 'Nazione',
        controlName: 'country',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'province-field',
        label: 'Provincia',
        controlName: 'province',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'place-field',
        label: 'Città',
        controlName: 'place',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'postalCode-field',
        label: 'CAP',
        controlName: 'postalCode',
        css: 'col-3'
    },
    {
        id: 'toponym-field',
        label: 'Toponimo (via, corso,...)',
        controlName: 'toponym',
        css: 'col-3'
    },
    {
        id: 'address-field',
        label: 'Indirizzo',
        controlName: 'address',
        css: 'col-3'
    },
    {
        id: 'address-number-field',
        label: 'Numero Civico',
        controlName: 'addressNumber',
        css: 'col-3'
    },
];

export const address_change_enabling_map = {
    country: 'province',
    province: 'place',
    place: 'postalCode',
    postalCode: 'toponym',
    toponym: 'address',
    address: 'addressNumber'
}

export const hidden_field_foreign_state = ['province', 'place', 'postalCode'];

export interface IVariazioneRecapitoRequest {
    policyNumber: string;
    address: IAddress;
}

export interface IAddress {
    country: string;
    place: string;
    province: string;
    postalCode: string;
    toponym: string;
    address: string;
    addressNumber: string;
}